export default {
    install(Vue) {
        Vue.component('redactor', require('../components/Redactor').default);
    },
};